// GET /api/password-resets/{token} → 200. Nothing else: the holder of a reset link learns
// no name and no role.
export type PasswordResetPayload = {
	readonly email: string;
};

export type PasswordResetFetchedAction = {
	type: 'PASSWORD_RESET_FETCHED';
	payload: PasswordResetPayload;
};

export default (payload: PasswordResetPayload): PasswordResetFetchedAction => ({
	type: 'PASSWORD_RESET_FETCHED',
	payload,
});
